module.exports = __webpack_public_path__ + "img/Frame-49.715ac006.svg";